import React from 'react';
import styles from './welcomeVideo.module.css';

interface WelcomeVideoPlayerProps {
  embedUrl: string;
  title: string;
}

const WelcomeVideoPlayer: React.FC<WelcomeVideoPlayerProps> = ({ embedUrl, title }) => (
  <div className={styles.player}>
    <iframe
      className={styles.iframe}
      src={embedUrl}
      title={title}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    />
  </div>
);

export default WelcomeVideoPlayer;
